import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import * as SearchQueryActions from 'rebook/apps/search/actions/SearchQueryActions';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import uaDetector from 'rebook/apps/utils/uaDetector';
import { pop } from 'rebook/apps/users/actions/NotificationActions';

import styles from './style.scss';


class SearchLine extends React.Component {
  constructor(props) {
    super(props);
    const { value } = props.searchQuery;
    this.timer = null;
    const UA = navigator && navigator.userAgent ? navigator.userAgent : null;
    this.state = {
      searchQuery: value || '',
      isFocused: props.isFocused,
      isMobile: uaDetector.isMobile(UA),
    };
  }

  componentDidMount() {
    // parse searchQuery from address line to component
    const { isFocused } = this.state;
    if (isFocused) {
      this.searchInput.focus();
    }
    this.props.SearchQueryActions.initQuery(this.props.history);
  }

  componentDidUpdate(prevState) {
    const { value } = this.props.searchQuery;

    if (prevState.searchQuery.value !== value) {
      this.setState({ searchQuery: value });
    }
  }

  handleUpdateQueryAction() {
    const { searchQuery } = this.state;
    const searchQueryTrimmed = searchQuery.trim();
    if (searchQueryTrimmed.length > 2) {
      return this.props.SearchQueryActions.updateQuery(searchQueryTrimmed, this.props.history);
    }
    const popupMessage = {
      message: 'Поисковый запрос слишком короткий',
      type: 'error',
    };
    const { message, type } = popupMessage;
    this.props.pop(message, type);
  }

  handleChange(event) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.setState({ searchQuery: event.target.value, isFocused: true });
    this.timer = setTimeout(() => {
      this.handleUpdateQueryAction();
    }, 1500);
  }

  handleClean() {
    this.props.SearchQueryActions.updateQuery(null);
    this.props.SearchQueryActions.setLoadingStatus(false);
    this.searchInput.focus();
  }

  handleCancel() {
    this.props.SearchQueryActions.cancelQuery(this.props.history);
    ga('send', 'event', 'Search', 'CloseInput');
    this.setState({ isFocused: false });
    this.searchInput.blur();
  }

  handleFocus(event) {
    this.setState({ isFocused: true });
    ga('send', 'event', 'Search', 'PressInput');
    const { onFocus } = this.props;
    if (onFocus) {
      this.props.onFocus(event);
    }
  }

  handleBlur(event) {
    this.setState({ isFocused: false });
    const { onBlur } = this.props;
    if (onBlur) {
      this.props.onBlur(event);
    }
  }

  hidePlaceholder() {
    this.searchInput.focus();
  }

  render() {
    const { showCancelButton } = this.props;
    const { value, isActive, isLoading } = this.props.searchQuery;
    const { searchQuery, isFocused, isMobile } = this.state;

    const cancelButton = (
      <button
        className={styles.cancel}
        onClick={() => this.handleCancel()}>
        Отмена
      </button>
    );

    return (
      <div className={classNames(styles.search, { isActive, isMobile })}>
        <div className={styles.searchContent}>
          <div className={classNames(styles.darkInputWrapper, { isFocused, isMobile })}>
            <input
              className={classNames(styles.darkInput, 'jest-search-input')}
              value={searchQuery || ''}
              type="text"
              maxLength="50"
              ref={(searchInput) => { this.searchInput = searchInput; }}
              onChange={(event) => this.handleChange(event)}
              onFocus={(event) => this.handleFocus(event)}
              onBlur={() => this.handleBlur()} />
            {isLoading
              ? (
                <span className={styles.darkInputLoadingPlaceholder}>
                  <SpinnerLoader width="16px" height="16px" />
                </span>
              )
              : (
                <span className={styles.darkInputPlaceholder} onClick={() => this.hidePlaceholder()}>
                  Книга или автор
                </span>
              )}
            {value && (
              <div className={styles.clean} onClick={() => this.handleClean()} />
            )}
          </div>
        </div>
        {(isActive && showCancelButton) && cancelButton}
      </div>
    );
  }
};

SearchLine.defaultProps = {
  showCancelButton: true,
  isFocused: false,
};

SearchLine.propTypes = {
  showCancelButton: PropTypes.bool,
  isFocused: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    searchQuery: state.searchQuery,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchQueryActions: bindActionCreators(SearchQueryActions, dispatch),
    pop: (message, type) => dispatch(pop(message, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchLine);
